import { useEffect } from 'react'
import { useToastStore } from '@repo/store/useToastStore'

export const useNavBlockerForOffline = () => {
  const { isOnline } = useToastStore()

  useEffect(() => {
    if (isOnline) return

    const blockClick = (event) => {
      event.preventDefault()
      event.stopImmediatePropagation()
    }

    const blockUnload = (event) => {
      event.preventDefault()
      event.returnValue = ''
    }

    document.addEventListener('click', blockClick, true)
    window.addEventListener('beforeunload', blockUnload)

    return () => {
      document.removeEventListener('click', blockClick, true)
      window.removeEventListener('beforeunload', blockUnload)
    }
  }, [isOnline])
}
